/**
 * Interpreta la respuesta de POST Turnos/obras-sociales/{osId}/validar-elegibilidad-afiliado.
 * Puede traer `ws`, `padronGecros.data`, o ambos; cada rama con `afiliadoValido` debe ser true.
 */
function ramasValidacionDesdeRoot(root) {
  if (root == null || typeof root !== 'object') return []
  const out = []
  const ws = root.ws
  if (ws != null && typeof ws === 'object' && !Array.isArray(ws)) {
    out.push(ws)
  }
  const pg = root.padronGecros
  const inner = pg?.data
  if (inner != null && typeof inner === 'object' && !Array.isArray(inner)) {
    out.push(inner)
  }
  return out
}

function ramaEsValida(r) {
  return r.afiliadoValido === true
}

function textoDisplayRama(r) {
  const d = r.display
  if (d == null) return ''
  return String(d)
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim()
}

/**
 * @returns {{ ok: boolean, mensaje: string }}
 */
export function interpretarRespuestaValidacionAfiliado(data) {
  const root = data?.data ?? data
  const ramas = ramasValidacionDesdeRoot(root)
  if (ramas.length === 0) {
    return { ok: true, mensaje: '' }
  }
  const todasOk = ramas.every(ramaEsValida)
  if (todasOk) {
    return { ok: true, mensaje: '' }
  }
  const partes = ramas
    .filter((r) => !ramaEsValida(r))
    .map(textoDisplayRama)
    .filter(Boolean)
  const mensaje =
    partes.join('\n\n').trim() || 'No se pudo validar la elegibilidad del afiliado.'
  return { ok: false, mensaje }
}
